
import './App.css';
import { useState } from 'react';
import ContactUs from './components/hero-section/ContactUs';
import Footer from './components/hero-section/footer/Footer';
import FormComponent from './components/hero-section/FormComponent';
import HeroSection from './components/hero-section/HeroSection';
import Join from './components/hero-section/join/Join';
import Plans from './components/hero-section/plans/Plans';
import Programs from './components/hero-section/programs/Programs';
import Reasons from './components/hero-section/reasons/Reason';
import Testimonials from './components/hero-section/testimonials/Testimonials';
// import Workout from './components/hero-section/Workout'; // Workout page
import { Route, Routes } from 'react-router-dom';
//work
import '../src/components/hero-section/Workout_Diet/workout.module.css';
import Absworkout from './components/hero-section/Workout_Diet/absworkout';
import Absworkout2 from './components/hero-section/absworkout';
import Armsworkout from './components/hero-section/Workout_Diet/armsworkout';
import Backworkout from './components/hero-section/Workout_Diet/backworkout';
import Chestworkout from './components/hero-section/Workout_Diet/chestworkout';
import Legsworkout from './components/hero-section/Workout_Diet/legsworkout';
import Shoulderworkout from './components/hero-section/Workout_Diet/shoulderworkout';
import Workout from './components/hero-section/Workout_Diet/workout';
// diet
import DietSection from './components/hero-section/Diet/DietSection';
// login
import Login from './login';
import Register from './register';
import App2 from '../src/reccomendation/App2'
// reccomendation
import Gender from './reccomendation/genderform';
import Age from './reccomendation/age';
import FitnessGoal from './reccomendation/fitnessgoal';
import YourLevel from './reccomendation/yourlevel';
import BodyLevel from './reccomendation/bodyparts';
import Generate from './reccomendation/generate';
import Display from './reccomendation/Succes';
function App() {
  const [userData, setUserData] = useState({
    gender: '',
    age: 25,
    weight: 70,
    height: 5,
    fitnessGoal: '',
    yourLevel: '',
    bodyPart: '',
});

const updateUserData = (data) => {
    setUserData(prevData => ({ ...prevData, ...data }));
};
  return (
   <>
      
      <div className="App">
        <Routes>
          {/* Home page route */}
          <Route
            path="/"
            element={
              <>
              
                <HeroSection />
                <Programs />
                <Reasons />
                <Plans />
                <Testimonials />
                <Join />
                <Footer />
                
              </>
            }
            />
          {/* Workout page route */}
          <Route path="workout" element={<Workout />} />
          {/* Diet page route */}
          <Route path="diet" element={<DietSection />} />
          <Route path="form" element={<FormComponent/>}/>
          <Route path="Contact" element={<ContactUs/>}/>
          <Route path="/workout" element={<Workout/>}/>
        <Route path="/absworkout" element={<Absworkout/>}/>
        <Route path="/coach-consultant" element={<Absworkout2/>}/>
        <Route path="/backworkout" element={<Backworkout/>}/>
        <Route path="/armsworkout" element={<Armsworkout/>}/>
        <Route path="/legsworkout" element={<Legsworkout/>} />
        <Route path="/chestworkout" element={<Chestworkout/>}/>
        <Route path="/shoulderworkout" element={<Shoulderworkout/>} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
                <Route path="/recommendation" element={<Gender updateUserData={updateUserData} />} />
                <Route path="/age" element={<Age updateUserData={updateUserData} userData={userData} />} />
                <Route path="/fitnessgoal" element={<FitnessGoal updateUserData={updateUserData} />} />
                <Route path="/yourlevel" element={<YourLevel updateUserData={updateUserData} />} />
                <Route path="/bodylevel" element={<BodyLevel updateUserData={updateUserData} userData={userData} />} />
                <Route path="/generate" element={<Generate userData={userData} />} />
                <Route path="/success" element={<Display />} />
        </Routes>
      </div>
   
      </>
  );
}

export default App;
